import { render, staticRenderFns } from "./ProjectAddOtherInfo.vue?vue&type=template&id=38cb2f6f"
import script from "./ProjectAddOtherInfo.vue?vue&type=script&lang=js"
export * from "./ProjectAddOtherInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports